module.exports = __webpack_public_path__ + "img/mobile_pink_cloud_1.bbb39353.svg";